var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTag3Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17501 1.5752L15.5993 2.63645L16.6598 10.0614L9.76576 16.9554C9.62511 17.096 9.43438 17.175 9.23551 17.175C9.03664 17.175 8.84591 17.096 8.70526 16.9554L1.28026 9.53045C1.13966 9.3898 1.06067 9.19907 1.06067 9.0002C1.06067 8.80132 1.13966 8.61059 1.28026 8.46995L8.17501 1.5752ZM8.70526 3.1667L2.87101 9.0002L9.23551 15.3639L15.069 9.53045L14.274 3.9617L8.70526 3.1667ZM10.2953 7.9397C10.0139 7.65823 9.85587 7.27653 9.85594 6.87856C9.85598 6.6815 9.89482 6.48638 9.97027 6.30433C10.0457 6.12229 10.1563 5.95689 10.2956 5.81757C10.435 5.67825 10.6004 5.56775 10.7825 5.49237C10.9646 5.417 11.1597 5.37822 11.3568 5.37825C11.7548 5.37832 12.1364 5.53648 12.4178 5.81795C12.6991 6.09941 12.8571 6.48111 12.8571 6.87909C12.857 7.27706 12.6988 7.65871 12.4174 7.94007C12.1359 8.22143 11.7542 8.37946 11.3562 8.37939C10.9583 8.37932 10.5766 8.22116 10.2953 7.9397Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag3Line);
export default __webpack_public_path__ + "static/media/price-tag-3-line.1c94482f8f27a7607cfff640c8a089bb.svg";
export { ForwardRef as ReactComponent };